(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('FontDialogCtrl', fontDialogCtrl);

    function fontDialogCtrl(
        $scope,
        $mdDialog,
        $timeout,
        $location,
        LibrariesAPIService,
        FontManagerService,
        blockUI,
        initialPosition,
        initialSort,
        library,
        element
    ) {
        $scope.element = element;
        $scope.fontOption = initialPosition;
        $scope.fontSort = initialSort;
        $scope.categoryId = $location.search().categoryId;
        $scope.errorMessage = '';
        $scope.fonts = FontManagerService.getLoadedFonts();
        if ($scope.fonts.length) {
            $scope.currentFontPath = $scope.fonts.find(function (f) {
                return f.Name.toLowerCase() === 'arial';
            }).Path;
        }

        // Set option if available. If element is not null we are in edit mode.
        if (element != null) {
            $scope.fontOption = element.position;
            $scope.fontSort = element.Sort;
            $scope.currentFontPath = element.Path;
        }

        $scope.create = function () {
            // If element is not null we are in edit mode, update the element instead of creating it
            if (element === null) {
                blockUI.start('Saving font');
                LibrariesAPIService.addElement(
                    library.LibraryId,
                    $scope.fontOption,
                    {
                        path: $scope.currentFontPath,
                        LibraryCategoryId: $scope.categoryId
                    },
                    'font',
                    null,
                    $scope.fontSort
                )
                    .then(function () {
                        // New font added!
                        blockUI.stop();
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        if (e.status === 409) {
                            $scope.errorMessage = "There's already an element at position " + $scope.fontOption;
                        }
                    });
            } else {
                // Update font
                element.path = $scope.currentFontPath;
                element.LibraryCategoryId = $scope.categoryId;

                blockUI.start('Updating font');
                LibrariesAPIService.updateElement(library.LibraryId, element.FontId, element, 'font')
                    .then(function () {
                        // Font updated!
                        blockUI.stop();
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        blockUI.stop();
                        $scope.errorMessage = 'Error updating font!';
                    });
            }
        };

        $scope.uploadFont = function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                $scope.uploadingFont = true;
                $scope.fontUploadPercent = 0;

                blockUI.start('Uploading font');
                FontManagerService.uploadFont(files[0], function (progress) {
                    $scope.fontUploadPercent = progress;
                })
                    .then(function () {
                        // Font uploaded! Reload fonts list
                        $scope.uploadingFont = false;
                        FontManagerService.getAllFonts()
                            .then(function (fonts) {
                                $scope.fonts = fonts;
                                blockUI.stop();
                                $timeout(() => $scope.$apply());
                            })
                            .catch(function (e) {
                                blockUI.stop();
                                $timeout(() => $scope.$apply());
                            });
                    })
                    .catch(function (error) {
                        // Font upload error
                        blockUI.stop();
                        $mdDialog.show(
                            $mdDialog
                                .alert()
                                .parent(document.body)
                                .clickOutsideToClose(true)
                                .multiple(true)
                                .title('Invalid Font!')
                                .textContent(error)
                                .ok('OK!')
                        );
                        $timeout(() => $scope.$apply());
                        $scope.uploadingFont = false;
                    });
            }
        };

        $scope.deleteFont = function (font) {
            // Save the current font path because when we click on the delete icon the font is also selected so we
            //  want to go back to the current font after deletion
            var fontPath = $scope.currentFontPath;

            FontManagerService.deleteFont(font).then(function (fontDeleted) {
                if (fontDeleted) {
                    FontManagerService.getAllFonts()
                        .then(function (fonts) {
                            $scope.fonts = fonts;
                            blockUI.stop();
                            $timeout(() => $scope.$apply());
                        })
                        .catch(function (e) {
                            blockUI.stop();
                            $timeout(() => $scope.$apply());
                        });
                }
                $scope.currentFontPath = fontPath;
            });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
